import React from 'react';
import {Link} from "react-router-dom";

export default ({name, url, icon}) => (
	<li>
		<Link variant={"text"} to={url}>
			<i className={"fa fa-" + icon}/>
			<span>{name}</span>
			<i className="fa fa-angle-right"/>
		</Link>
	</li>
);
